import Home from '../Home.vue'
import appList from './application/list.vue'
import appAdd from './application/add.vue'
import appEdit from './application/edit.vue'
import pageList from './page/list.vue'
import pageAdd from './page/add.vue'
import pageEdit from './page/edit.vue'

import contentConfig from './page/abstract/contentConfig.vue'
import goTop from './page/abstract/goTop.vue'

import box from './page/abstract/box.vue'

const routes = [
  {
    path: '/home',
    component: Home,
    children: [
      { path: '/application/list', component: appList, name: 'appList', meta: { hideLeft: false, module: 'Administrative', menu: 'application' }},
      { path: '/application/add', component: appAdd, name: 'appAdd', meta: { hideLeft: false, module: 'Administrative', menu: 'application' }},
      { path: '/application/edit/:id', component: appEdit, name: 'appEdit', meta: { hideLeft: false, module: 'Administrative', menu: 'application' }},
      { path: '/page/list', component: pageList, name: 'pageList', meta: { hideLeft: false, module: 'Administrative', menu: 'page' }},
      { path: '/page/add', component: pageAdd, name: 'pageAdd', meta: { hideLeft: false, module: 'Administrative', menu: 'page' }},
      { path: '/page/edit/:id', component: pageEdit, name: 'pageEdit', meta: { hideLeft: false, module: 'Administrative', menu: 'page' }}
    ]
  },
  {
    path: '/home',
    component: Home,
    children: [
      { path: '/page/contentConfig/:pageId/:id', component: contentConfig, name: 'contentConfig', meta: { hideLeft: false, module: 'Administrative', menu: 'page' }},
      { path: '/page/goTop/:pageId/:id', component: goTop, name: 'goTop', meta: { hideLeft: false, module: 'Administrative', menu: 'page' }},

      { path: '/page/box/:id', component: box, name: 'box', meta: { hideLeft: false, module: 'Administrative', menu: 'page' }}
    ]
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/components/Mobile/routes.js